<template lang="pug">
	div
		title-with-reviews.mb-4(:title="name" :reviews="reviews" :reviews-link="`${path}#reviews`")
		vue-plyr.mb-4(v-if="video && (video.videoSource === 'youtube' || video.videoSource === 'vimeo')" ref="plyr" :options="{ 'disableContextMenu': false}" :key="video.videoId")
			div(:data-plyr-provider="video.videoSource" :data-plyr-embed-id="video.videoId")
		video-hls(v-else-if="video && video.videoSource === 'video'" :videoUrl="video.videoId")
		piste-table(:pistes="pistes")
		ws-content.mt-3(:value="content" v-if="content" level="2")
			template(v-if="galleryPhotos.length")
				v-container.pa-0
					v-row
						v-col(v-for="(photo, index) in galleryPhotos.slice(0,3)" :key="photo.index")
							v-img(:src="`${photo.thumb}`" :aspect-ratio="16/9"  @click="openGallery(index)" v-ripple :lazy-src="photo.loading")
				client-only
					lightbox(:media="galleryPhotos" :showLightBox="false" ref="lightbox")
			portal(to="sidebar" :disabled="this.$vuetify.breakpoint.smAndDown" :order="1")
				v-card.mb-6(outlined)
					v-card-text
						v-img(v-if="galleryPhotos.length" :aspect-ratio="16/9" :src="`${galleryPhotos[0].thumb}?width=320`"  @click="openGallery(0)" :alt="galleryPhotos[0].alt"  :lazy-src="galleryPhotos[0].loading")
							img(v-if="approval" :src="require('~/assets/images/associate_member_nskiv.svg')" style="width: 80px; position: absolute; right: 10px; top: -1px;")
					factsheet(:facts="facts")
					v-card-text.text--primary
						strong Locatie
						address-display(:address="address")
				div(v-if="trips.length")
					trip-card.mb-6(v-bind="trip" v-for="trip in trips" :key="trip.id" :outlined="true")
				v-card.mb-6(outlined color="info" v-if="features.length")
					v-card-text.text--primary
						features(:features="features")
			h2 Prijzen
			v-data-table(class="static-table" :items="prices" hide-default-footer no-pagination  :mobile-breakpoint="0" :headers="priceTableHeaders")
				template(#item="{item}")
					tr
						td.font-weight-bold {{item.name}}
						td.text-right(v-if="item.adultOffer")
							s.grey--text {{ $n(item.adult, 'currency', $i18n.locale) }}
							|  {{ $n(item.adultOffer, 'currency', $i18n.locale) }}
						td.text-right(v-else) {{ $n(item.adult, 'currency', $i18n.locale) }}
						td.text-right(v-if="item.youthOffer")
							s.grey--text {{ $n(item.youth, 'currency', $i18n.locale) }}
							|  {{ $n(item.youthOffer, 'currency', $i18n.locale) }}
						td.text-right(v-else) {{ $n(item.youth, 'currency', $i18n.locale) }}
						td.text-right(v-if="affiliateLink")
							v-btn(color="warning" depressed small :href="affiliateLink" target="_blank" rel="nofollow") reserveer
			.text-center.my-3(v-if="affiliateLink")
				v-btn( color="primary" outlined :href="affiliateLink" target="_blank" rel="nofollow") koop e-tickets
			v-divider.my-6
		portal(to="sidebar" :disabled="this.$vuetify.breakpoint.smAndDown" :order="2")
			ad(location="sidebar").mb-6
		.flow-left
			h2#reviews.mt-3 {{$t('page.areas._area.reviews:rate_heading.{area}', { area: name })}}
			add-rating(v-bind="{type:'skihall', id:id}" @rated="rated")
			add-review-dialog(v-bind="{type:'skihall', id:id, destination: {name: name}}" :initial-rating="rating" v-model="showReviewDialog" @reviewed="reviewed")
			v-divider.my-6
		.flow-left
			template(v-if="reviews.nodes.length > 0")
				h2 {{$tc('page.areas._area:reviews.heading_{rating}_{count}', reviews.total, {rating: reviews.average, count: reviews.total})}}
				review-list(:items="reviews.nodes")
		.flow-left
			h2.mt-3 {{$t('page.areas._area.forum:heading_{area}', { area: name })}}
			div(v-if="!forum.topics.length")
				| {{$t('forum.no-data_{area}',{ area: name })}}
				.text-center
					add-topic-dialog(v-model="showNewTopicDialog" initial-category="destination" :initial-destination="{name:name,id:id,__typename:'Skihall'}")
					login-action(@on-click="showNewTopicDialog = true")
						template(#activator="{ on }")
							v-btn.mt-6(color="primary" outlined v-on="on") {{$t('forum:ask.first.question')}}

			topic-list(v-else :topics="forum.topics" hide-last-visit-bar hide-destination :destination="{name:name,id:id,__typename:'Skihall'}")
			v-divider.my-6
		portal(to="sidebar" :disabled="this.$vuetify.breakpoint.smAndDown" :order="3")
			offers
		.flow-left
			template(v-if="similars.length")
				h2.mt-3 {{$t('page.localdestinations._localdestination.similar:heading')}}
				v-simple-table.similar-table
					slot(name="table-header")
						thead
							tr.table-header
								th
								th.text-left {{name}}
								template(v-for="similar in similars")
									th.text-left
										magic-nuxt-link(:to="similar") {{similar.name}}
						tbody
							tr
								th
								td
									v-img(v-if="photos.length" :aspect-ratio="16/9" :src="`${comparePhotos(photos)[0].thumb}?width=320`" :alt="comparePhotos(photos)[0].alt" :lazy-src="comparePhotos(photos)[0].loading")
								template(v-for="similar in similars")
									td
										v-img(v-if="similar.photos.length" :aspect-ratio="16/9" :src="`${comparePhotos(similar.photos)[0].thumb}?width=320`" :alt="comparePhotos(similar.photos)[0].alt" :lazy-src="comparePhotos(similar.photos)[0].loading")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.longestpiste')}}
								td {{longestPisteLength}}m
								template(v-for="similar in similars")
									td {{similar.longestPisteLength}}m
							//- tr
							//- 	th{{$t('page.localdestinations._localdestination.similar:table.maxheight')}}
							//- 	td
							//- 	template(v-for="similar in similars")
							//- 		td
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.pistelength')}}
								td {{pistes.length}}
								template(v-for="similar in similars")
									td {{similar.pistes.length}}
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.chairlift')}}
								td {{chairlift}}
								template(v-for="similar in similars")
									td {{similar.chairlift}}
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.tbar')}}
								td {{tbar}}
								template(v-for="similar in similars")
									td {{similar.tbar}}
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.magiccarpet')}}
								td {{magiccarpet}}
								template(v-for="similar in similars")
									td {{similar.magiccarpet}}
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.pistes')}}
								td
									check(:value="hasFeature('pistes', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('pistes', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.lifts')}}
								td
									check(:value="hasFeature('lifts', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('lifts', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.crowd')}}
								td
									check(:value="hasFeature('crowd', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('crowd', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.authentic')}}
								td
									check(:value="hasFeature('authentic', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('authentic', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.price')}}
								td
									check(:value="hasFeature('price', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('price', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.funpark')}}
								td
									check(:value="hasFeature('funpark', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('funpark', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.restaurants')}}
								td
									check(:value="hasFeature('restaurants', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('restaurants', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.kids')}}
								td
									check(:value="hasFeature('kids', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('kids', similar.features)")
							tr
								th {{$t('page.localdestinations._localdestination.similar:table.snow')}}
								td
									check(:value="hasFeature('snow', features)")
								template(v-for="similar in similars")
									td
										check(:value="hasFeature('snow', similar.features)")
</template>

<script>
import gql from 'graphql-tag';
import TitleWithReviews from '@dengl/common/components/title-with-reviews';
import TopicList from '@dengl/common/components/forum/topic-list.vue';
import Content from '@dengl/common/components/content.vue';
import AddRating from '@/components/add-rating';
import AddressDisplay from '@/components/localdestinations/address';
import AddReviewDialog from '@/components/add-review-dialog';
import AddTopicDialog from '@/components/forum/add-topic-dialog';
import Factsheet from '@/components/localdestinations/factsheet';
import Features from '@/components/localdestinations/feature-list';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import PisteTable from '@/components/localdestinations/piste-table.vue';
import ReviewList from '@/components/review-list.vue';
import UserContentDetails from '@/components/user-content/fragments.js';
import { interpolateFields } from '@/utils/interpolate.js';
import TripCard from '@/components/trips/card.vue';

const Check = {
	functional: true,
	render(createElement, context) {
		if (context.props.value) {
			return createElement(
				'ws-icon',
				{ props: { color: 'success', size: '20' } },
				['check']
			);
		} else {
			return createElement('span', { class: 'grey--text' }, ['•']);
		}
	}
};

const query = gql`
	query getSkihallPage($slug: String!) {
		skihall(slug: $slug) {
			id
			name
			slug
			logo
			affiliateUrl
			isActive
			approval
			chairlift
			tbar
			magiccarpet
			address {
				city
				street
				phone
				postcode
				country
				url
				countrycode
			}
			features {
				title
				rating
				text
				type
			}
			photos {
				url
				alt
				caption
			}
			videos {
				videoId
				videoSource
				isDefault
			}
			prices {
				name
				adult
				adultOffer
				youth
				youthOffer
			}
			longestPisteLength
			pistes {
				name
				color
				width
				length
			}
			tags
			...MetaFragment
			reviews {
				nodes {
					...UserContentDetails
				}
				average
				voteCount
			}
			content {
				...ContentDataFragment
			}
			geography {
				location {
					coordinates
				}
			}
			forum: topics(limit: 50) {
				...TopicListFragment
			}
			similars {
				id
				name
				slug
				longestPisteLength
				chairlift
				tbar
				magiccarpet
				pistes {
					name
				}
				features {
					rating
					type
				}
				photos {
					url
					alt
					caption
				}
			}
			trips {
				id
				name
				slug
				image: hotelPhoto
				introduction
				bulletpoints
				tags
			}
		}
	}
	${UserContentDetails}
	${MetaFragment}
	${TopicList.fragments}
	${Content.fragments}
`;

export default {
	name: 'LocalDestinationSkihallSlug',
	nuxtI18n: {
		paths: {
			'nl-NL': '/skihallen/:slug',
			'nl-BE': '/skihallen/:slug'
		}
	},
	components: {
		AddRating,
		AddressDisplay,
		AddReviewDialog,
		AddTopicDialog,
		Check,
		Factsheet,
		Features,
		PisteTable,
		ReviewList,
		TitleWithReviews,
		TopicList,
		TripCard
	},
	asyncData({ params, app, route }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query,
				variables: {
					slug: params.slug
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				const interpolationData = {
					skihall: data.skihall.name,
					country: data.skihall.address.country,
					'slopes.longest': data.skihall.longestPisteLength,
					'reviews.average': data.skihall.reviews.average,
					'reviews.total': data.skihall.reviews.total
				};
				app.interpolater = interpolateFields({
					find: RegExp(`{(${Object.keys(interpolationData).join('|')})}`, 'gi'),
					replace: (match, group) => {
						return interpolationData[group];
					}
				});
				app.interpolater(data.skihall.meta, ['title', 'description']);

				app.meta(data.skihall.meta);
				app.breadcrumbs({
					'Wintersport in de buurt': { name: 'localdestinations' },
					Skihallen: { name: 'localdestinations-skihalls' },
					[data.skihall.name]: {
						name: 'localdestinations-skihalls-slug',
						params: { slug: data.skihall.slug }
					}
				});

				return { ...data.skihall, path: route.path };
			})
			.catch(error => {
				return app.httpError(
					500,
					null,
					'localdestinations-skihalls-slug-01',
					error
				);
			});
	},
	data() {
		return { showReviewDialog: false, rating: 0, showNewTopicDialog: false };
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		longestPiste() {
			return this.longestPisteLength;
		},
		galleryPhotos() {
			return this.photos.map(photo => {
				return {
					loading: photo.url + '?width=48',
					thumb: photo.url + '?width=320',
					src: photo.url + '?width=1280',
					caption: `${photo.caption}`
					// srcset: null
				};
			});
		},
		priceTableHeaders() {
			return [
				{ text: '', value: 'name', sortable: false },
				{
					text: 'Volwassenen',
					value: 'adult',
					sortable: false,
					align: 'right'
				},
				{ text: 'Jeugd', value: 'width', sortable: false, align: 'right' },
				this.affiliateLink ? { text: '', sortable: false, width: '10%' } : null
			].filter(p => !!p);
		},
		video() {
			return this.videos.find(video => {
				return video.isDefault;
			});
		},
		affiliateLink() {
			return this.affiliateUrl
				? `/redir?u=${encodeURIComponent(this.affiliateUrl)}&i=${
						this.id
				  }&t=localdestination&h=${this.$redirHash(this.affiliateUrl)}`
				: null;
		},
		facts() {
			return [
				{
					value: this.longestPiste,
					icon: 'distance',
					label: 'Langste afdaling',
					display: `${this.longestPiste}m`
				},
				{
					value: this.chairlift,
					icon: 'chair-lift',
					label: 'Stoeltjesliften'
				},
				{ value: this.tbar, icon: 't-bar', label: 'Sleepliften' },
				{
					value: this.magiccarpet,
					icon: 'conveyor',
					label: 'Lopende banden'
				}
			];
		}
	},
	methods: {
		reviewed(review) {
			this.reviews.nodes.unshift(review);
		},
		rated(rating) {
			this.rating = rating;
			this.showReviewDialog = true;
		},
		openGallery(index) {
			this.$refs.lightbox.showImage(index);
		},
		hasFeature(type, features) {
			const feature = features.find(f => f.type.toLowerCase() === type);
			return !(!feature || feature.rating <= 2);
		},
		comparePhotos(photos) {
			return photos.map(photo => {
				return {
					loading: photo.url + '?width=48',
					thumb: photo.url + '?width=320',
					src: photo.url + '?width=1280',
					caption: `${photo.caption}`
					// srcset: null
				};
			});
		}
	}
};
</script>

<style lang="sass">
.similar-table
	th
		font-weight: bold
		text-align: right !important
		height: 40px !important
		width: 25%
	td
		text-align: center
</style>
